<template>
  <li @click="onToPost()">
    <div class="avatar" v-if="item.user">
      <img class="img" :src="item.user.avatar" />
      <div class="info">
        <p class="name">{{ item.user.nickname }}</p>
        <div class>
          <p class="time" v-if="item.created_at">{{ item.created_at.replace(/-/g, "/") }}</p>
          <p class="from">
            来自
            <span @click.stop="onToGroup()">{{ item.group_name }}</span>小组
          </p>
        </div>
      </div>
    </div>
    <div class="content">
      <p class="name vmiddle">
        <span class="tag-top" v-show="item.is_top">置顶</span>
        <span class="tag-fine" v-show="item.is_fine">精</span>
        <span class="title-text eps">{{ item.title }}</span>
      </p>
      <p class="message" v-html="item.content"></p>
      <div class="set-box">
        <p class="zan">
          <span>{{ item.like_num }}</span>
        </p>
        <p class="comment">
          <span>{{ item.comment_num }}</span>
        </p>
        <p class="browse">
          <span>{{ item.click_num }}</span>
        </p>
      </div>
    </div>
    <a
      class="operate delete"
      v-if="$store.state.user_info.id==item.user_id"
      @click.stop="onDelete(item)"
    >删除</a>
    <a class="operate" v-else @click.stop="onComplaint">举报</a>
  </li>
</template>
<script>
export default {
  name: "CommunityItem",
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      }
    },
    toPostQuery: {
      type: Object
    },
    toGroupQuery: {
      type: Object
    }
  },
  methods: {
    onToPost() {
      const queryObj = {
        group_id: this.item.group_id
      };
      if (this.toPostQuery) {
        Object.assign(queryObj, this.toPostQuery);
      }
      this.$router.push({
        name: "CommunityShow",
        params: { id: this.item.id },
        query: queryObj
      });
    },
    onToGroup() {
      const queryObj = {};
      if (this.toGroupQuery) {
        Object.assign(queryObj, this.toGroupQuery);
      }
      this.$router.push({
        name: "CommunityGroupShow",
        params: { id: this.item.group_id },
        query: queryObj
      });
    },
    async onDelete(item) {
      await this.$promiseConfirm("删除后，该内容将不再展示，是否确认？", {
        type: "warning"
      });
      await this.$http.delete("/api/app/community/post/" + item.id);
      this.$emit("delete");
    },
    onComplaint() {
      this.$emit("complaint");
    }
  }
};
</script>
<style lang="scss" scoped>
li {
  width: 100%;
  padding: 24px 0;
  border-bottom: 1px solid #edf1f2;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  .operate {
    position: absolute;
    cursor: pointer;
    top: 28px;
    right: 0;
    font-size: 14px;
    color: rgba(89, 89, 89, 1);
    display: none;
    &:hover {
      color: $primary-color;
    }
    &.delete:hover {
      color: #e74d3d;
    }
  }
  &:hover {
    .operate {
      display: block;
    }
  }
  .avatar {
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    .img {
      width: 51px;
      height: 51px;
      border-radius: 50%;
      margin-right: 12px;
    }
    .info {
      display: inline-block;
      max-width: 100%;
      border-radius: 30px;
      box-sizing: border-box;
      .name {
        height: 21px;
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(32, 36, 42, 1);
        line-height: 21px;
      }
      div {
        display: flex;
        margin-top: 10px;
        p {
          margin-right: 15px;
          font-size: 12px;
          color: #8c8c8c;
          line-height: 12px;
          span {
            display: inline-block;
            margin: 0 5px;
            color: $primary-color;
            cursor: pointer;
          }
        }
      }
    }
  }
  .content {
    width: 100%;
    margin-top: 15px;
    .name {
      margin-bottom: 8px;
      .tag-top {
        background-color: #ff2e12;
        font-size: 12px;
        border-radius: 3px;
        color: #fff;
        padding: 2px 8px;
        margin-right: 8px;
      }
      .tag-fine {
        background-color: #fc9630;
        font-size: 12px;
        border-radius: 3px;
        color: #fff;
        padding: 2px 5px;
        margin-right: 12px;
      }
      .title-text {
        height: 37px;
        font-size: 19px;
        font-weight: 500;
        font-family: PingFangSC-Medium, PingFang SC;
        color: rgba(32, 36, 42, 1);
        line-height: 37px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .message {
      max-height: 60px;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      font-size: 14px;
      color: #8c8c8c;
    }
    .img-box {
      width: 360px;
      & /deep/ .el-image {
        display: block;
        width: 100%;
        height: 110px;
        margin-top: 20px;
        background-color: rgba(0, 0, 0, 0.1);
        cursor: zoom-in;
      }
    }
    .set-box {
      margin-top: 20px;
      overflow: hidden;
      line-height: 12px;
      text-align: right;
      p {
        font-size: 12px;
        color: #8c8c8c;
      }
      .zan {
        display: inline-block;
        padding-left: 16px;
        background: url("~@/assets/images/icon_fourm_zan.png") left 0 no-repeat;
        background-size: 11px 11px;
      }
      .comment {
        display: inline-block;
        margin-left: 30px;
        padding-left: 16px;
        background: url("~@/assets/images/icon_fourm_comment.png") left center
          no-repeat;
        background-size: 11px 11px;
      }
      .browse {
        display: inline-block;
        margin-left: 30px;
        padding-left: 20px;
        background: url("~@/assets/images/icon_fourm_browse.png") left 1px
          no-repeat;
        background-size: 14px 9px;
      }
    }
  }
}
</style>
